import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { environment } from './../../../../../environment/environment';
import { EsnAppeloffreService } from './../../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Component, ElementRef, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ISort, headerColumns2, translations } from './../../../../core/models/call-offer';
import { serverError } from './../../../../core/models/messages';
import { OffreEsnService } from './../../../../core/services/offre-esn/offre-esn.service';
import { SalarieService } from './../../../../core/services/salarie-service/salarie.service';
import { SortDataService } from './../../../../core/services/sortdata';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Country, State } from 'country-state-city';
import { EsnJobOfferService } from './../../../../core/services/esn-job-offer-service/esn-job-offer.service';
import { Subject, takeUntil } from 'rxjs';
import { DatePipe } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { Router } from '@angular/router';
import { SubscriptionService } from '@core/services/subscription.service';
import { PageEvent } from '@angular/material/paginator';
import { UserRole } from '@core/models/enums/user-role.enum';
@Component({
  selector: 'app-list-offers',
  templateUrl: './list-offers.component.html',
  styleUrls: ['./list-offers.component.css'],
})
export class ListOffersComponent  implements OnInit {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  freeSearchActive :boolean = false;
  isFormSubmitted: boolean = false;
  isFreeSearchFromSubmitted: boolean = false;
  freeSearch: boolean = false;
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  btnSearchactive : boolean = false;
  backGroundColors: string[] = ['blue', 'orange', 'bleu-clair', 'pink', 'rose'];
  loadSpinner: boolean = false;
  pagination : boolean =false;
  isLoadSpinner: boolean =true
  sortAttr = '';
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  itemsPerPage: number = 5;
  currentPage: number = 0;
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  listappeloffre: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  applyForm: FormGroup = this.createForm();
  private unsubscribeAll: Subject<void> = new Subject();
  seeMore: boolean = false;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  countries: any = [];
  stateList: any = [];
  mobilities: any[] = [];
  nameEsn = this.localStorageService.getData('clientConnectedName');
  listconsultant: any;
  selectedUserId!: string;
  iduser: any;
  isCollapsed = true;
  dataHeader: any = [];
  listNames: string[] = [];
  idoffre: any;
  currentUser: any;
  company_id: any;
  companyRoleId: any;
  profile = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  passeport = [
    { id: 1, name: 'Oui' },
    { id: 0, name: 'Non' },
  ];
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  disponibilite = [
    { id: 1, name: 'Immédiate' },
    { id: 3, name: '2 mois' },
    { id: 4, name: '3 mois' },
    { id: 5, name: '4 mois' },
    { id: 6, name: '5 mois' },
  ];
  contrat = [
    { id: 1, name: 'Alternance' },
    { id: 2, name: 'Autres type de contrat' },
    { id: 3, name: 'CDD' },
    { id: 4, name: 'CDI' },
    { id: 5, name: 'Freelance' },
    { id: 6, name: 'Portage salarial' },
    { id: 7, name: 'Stage' },
  ];
  poste = [
    { id: 1, name: 'A distance' },
    { id: 2, name: 'Hybride' },
    { id: 3, name: 'Sur site' },

  ];
  state = [
    { id: 0, name: 'Actif' },
    { id: 1, name: 'Non Actif' },
  ];
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns2;
  typeintervenant: any;
  idCompany:any;  
  startSearching:boolean = false;

  /** @TEMPORARY: temporary used to disable the following list :
   *
   * option: Archiver, action : archiveroffrebesoinesn
   */
  constructor(
    private formBuilder: FormBuilder,
    private offreesnservice: OffreEsnService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private salarieservice: SalarieService,
    private jobofferservice: EsnJobOfferService,
    private appelofferservice: EsnAppeloffreService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private datePipe: DatePipe,
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnInit() {
    this.typeintervenant =
      this.localStorageService.getData('typeintervenant');
    this.countries = Country.getAllCountries();
    this.getListoffrebesoinesn();
    this.getListSkills();
    this.getListElementHeader();
    this.getcurrentUser();
    if (!this.stateList.length) {
      this.searchForm.get('city')?.disable(); // Désactiver
    } else {
      this.searchForm.get('city')?.enable();  // Activer
    }
    this.contrat = this.contrat.sort((a, b) => {
      return a.name === 'Autres type de contrat' ? 1 : b.name === 'Autres type de contrat' ? -1 : 0;
    });
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
    this.primengConfig.setTranslation({
      dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
      dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
      monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
      today: 'Aujourd\'hui',
      clear: 'Effacer'
    });
  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  getContractTypeList(contractTypes: number[]): string {
    const contractMap: { [key: string]: string } = {
        '1': 'Alternance',
        '2': 'Autres type de contrat',
        '3': 'CDD',
        '4': 'CDI',
        '5': 'Freelance',
        '6': 'Portage salarial',
        '7': 'Stage'
    };

    if(Array.isArray(contractTypes)) return contractTypes?.map(type => contractMap[type.toString()] || '').join(', ');
    else return ''
  }
  getRemainingPays(pay: any): string {
    if (!Array.isArray(pay) || pay.length <= 3) {
      return ''; 
    }
    return pay.map(m => String(m)).join(', '); 
  }
  getSkillsArray(candidate: any): string[] {
    if (candidate && candidate.skills) {
      return candidate.skills.split(',').map((s: string) => s.trim());
    } else {
      return [];
    }
  }
  getSkillsList(skills: string): string {
    if (!skills) {
      return '';
    }
    return skills.split(',').map(s => s.trim()).join(', ');
  }
  getClass(item: string): string {
    if (item === 'Nom entreprise') {
      return 'th-fixed';
    } else if (item === 'Poste') {
      return 'th-fixed2';
    }
    return '';
  }
  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appelofferservice
        .getHeaderElements(13)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.jobofferservice
        .listPageesnjobofferActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.jobofferservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.jobofferservice
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }

  onCountryChange(mode: string): void {
    this.searchForm.get('city')?.enable();
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.map(
      (item: any) => this.paysList.filter((it) => it.name === item)[0]
    );

    this.stateList.length = 0;
    // if (event.length) {
    this.countries.forEach((item: any) => {
      this.stateList.push(State.getStatesOfCountry(item.isoCode));
    });
    this.stateList = this.stateList.flat();
    for (const iterator of this.stateList) {
      iterator.name = iterator.name.replace(' Governorate', '');
    }
    this.stateList = this.stateList.map((item: any) => item.name);
    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities != null && this.mobilities.length > 0) {
      let differentItemsArray1: any[] = [];
      differentItemsArray1 = this.mobilities.filter(
        (item) => !this.stateList.includes(item)
      );
      const differentItemsArray2 = this.mobilities.filter(
        (item) => !differentItemsArray1.includes(item)
      );
      this.searchForm.get('city')?.setValue(differentItemsArray2);
    }
    // }
    if (this.stateList.length == 0) {
      this.stateList = [];
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
    }
  }
  navigate(user : any,name : string) {
    this.router.navigate([
      '/chat/chat-list',
      { user: user,name:name},
    ]);
}
  onMobilityChange(mode: string) {
    this.mobilities = this.searchForm.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.searchForm.get('country')?.value;
    this.countries = this.countries.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );

            // this.searchForm.get('country')?.setValue(new_array);
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.searchForm.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.searchForm.get('city')?.disable();
      mode == 'add';
      this.searchForm.get('country')?.setValue(null);
      mode == 'add';
      this.searchForm.get('city')?.setValue(null);
      this.searchForm.get('country')!.updateValueAndValidity();
      this.searchForm.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }

  findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }

  getListoffrebesoinesn() {
    const params = {
      per_page: this.pageSize,
      page: this.currentPage}   
    this.spinner.show();
    this.offreesnservice.getListoffrebesoinesn(params).subscribe({
      next: (response: any) => {
        if (response.data && response.data.data) {
          this.totalItems = response.data.total;
          this.listappeloffre = response.data.data;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }

  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      ID_jobOffer: ['', data?.ID_jobOffer],
      name: ['', data?.name],
      esn_name: ['', data?.esn_name],
      skillsOr: [[], data?.skillsOr],
      skillsAnd: [[], data?.skillsAnd],
      availability: [[], data?.availability],
      contract_type: [[], data?.contract_type],
      post_type: [[], data?.post_type],
      years_of_experience: ['', data?.years_of_experience],
      experience_range: ['', data?.experience_range],
      city: [[], data?.city],
      country: [[], data?.country],
      tjm: ['', data?.tjm],
      tjm_range: ['', data?.tjm_range],
      desired_salary: ['', data?.desired_salary],
      desired_salary_range: ['', data?.desired_salary_range],
      start_date: ['', data?.start_date],
      end_date: ['', data?.end_date],
      state: [null, data?.state],
      profile_abroad: [null, data?.profile_abroad],
      passeport_talent: [null, data?.passeport_talent],
    });
  }

  onSalaryRangeInput(event: any) {
    const value = event.target.value;
    if (value.toLowerCase().endsWith('k')) {
      this.searchForm.controls['desired_salary_range'].setValue(
        this.convertKToNumber(value)
      );
    }
  }

  alreadyConverted = false;
  convertKToNumber(value: any): number {
    if (typeof value === 'string' && value.toLowerCase().endsWith('k')) {

      const numericValue = parseFloat(value.slice(0, -1));
      if (!isNaN(numericValue)) {

        this.alreadyConverted = true;
        return numericValue * 1000;
      }
    } else if (!isNaN(value)) {

      if (!this.alreadyConverted) {
        this.alreadyConverted = true;
        return parseFloat(value) * 1000;
      } else {
        return parseFloat(value);
      }
    }

    // Si aucune condition n'est remplie, retourner une valeur par défaut
    return 0; // Ou une autre valeur par défaut appropriée
  }

  setActiveForm(form: 'freeSearch' | 'guidedSearch') {
      this.activeForm = form;
      if (form === 'freeSearch') {
        this.freeSearchActive = true;
        this.freeSearchForm.enable();
      } else if (form === 'guidedSearch') {
        this.freeSearchActive = false;
        this.searchForm.enable(); 
      }
  }
  onReset() {
    this.stateList=[];
    this.currentPage = 0;
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm = this.createSearchForm();
    this.searchForm.reset();
    this.getListoffrebesoinesn();
  }

  onSubmit() {
    if(!this.freeSearchActive) {
      this.btnSearchactive = true;
      this.currentPage=0;
      this.searchoffrebesoinesn(this.currentPage);
    } else{
      this.btnSearchactive = true;
      this.currentPage=0;
      this.freeSearchOffreBesoinEsn(this.currentPage);
    }
  }
onPageChange(e: PageEvent): void {
  this.pageSize = e.pageSize;
  this.currentPage = e.pageIndex;
  if (this.searchForm.dirty && this.btnSearchactive) {
    this.searchoffrebesoinesn(this.currentPage);
  } 
  else if (this.freeSearchForm.dirty && this.btnSearchactive){
    this.freeSearchOffreBesoinEsn(this.currentPage);
  }
  else {
    this.getListoffrebesoinesn();
  }
}
  freeSearchOffreBesoinEsn(pageNumber: number = this.currentPage) {
    this.isFormSubmitted = false;
    this.isFreeSearchFromSubmitted = true;
    let valueForm = this.freeSearchForm.value;

    let formattedEndDate = this.datePipe.transform(valueForm.date_last_update, 'yyyy-MM-dd');
    let data = {
      end_date: formattedEndDate,
      per_page: this.pageSize,
      page: this.currentPage+1,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.offreesnservice.freeSearchoffrebesoinesn(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.spinner.hide();
              this.startSearching = false;
              this.listappeloffre = resSearch.data.data;
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }

  /* search */
  searchoffrebesoinesn(pageNumber : number = this.currentPage) {
    this.isFreeSearchFromSubmitted = false;
    this.isFormSubmitted = true;

    let valueForm = this.searchForm.value;
    let formattedEndDate = this.datePipe.transform(valueForm.end_date, 'yyyy-MM-dd');
    let formattedStartDate = this.datePipe.transform(valueForm.start_date, 'yyyy-MM-dd');
    valueForm.desired_salary_range = this.convertKToNumber(valueForm.desired_salary_range?.toString());

    let data = {
      ID_jobOffer: valueForm.ID_jobOffer,
      esn_name: valueForm.esn_name,
      name: valueForm.name,
      skillsOr: valueForm.skillsOr,
      skillsAnd: valueForm.skillsAnd,
      availability: valueForm.availability,
      contract_type: valueForm.contract_type,
      post_type: valueForm.post_type,
      years_of_experience: valueForm.years_of_experience,
      experience_range: valueForm.experience_range,
      city: valueForm.city,
      country: valueForm.country,
      tjm: valueForm.tjm,
      tjm_range: valueForm.tjm_range,
      desired_salary: this.searchForm.value.desired_salary,
      desired_salary_range: valueForm.desired_salary_range,
   
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      state: valueForm.state,
      profile_abroad: valueForm.profile_abroad,
      passeport_talent: valueForm.passeport_talent,
      page: this.currentPage,
      per_page: this.pageSize,
    };

    this.spinner.show();
    this.offreesnservice.searchoffrebesoinesn(data).subscribe({
      next: (resSearch) => {
        const { to, from, total, current_page, data } = resSearch.data;
        this.totalItems = resSearch.data.total;
        this.listappeloffre = resSearch.data.data;
        this.startSearching = false;
        this.spinner.hide();
      },
      error: (error) => {
        this.toastrService.error(serverError);
        this.spinner.hide();
      },
    });
  }
  getListSkills() {
    this.salarieservice.getSkills().subscribe({
      next: (res) => {
        this.skillsList = res.data;
      },
      error: () => {
        // this.toastrService.error(serverError);
      },
    });
  }
  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }

  isSimpleWord(value: string): boolean {
    const simpleWordPattern = /^[a-zA-Z0-9]+(\s[a-zA-Z0-9]+)?$/;
    return simpleWordPattern.test(value);
  }

  archiveroffrebesoinesn(id: any) {
    this.offreesnservice
          .archiveroffrebesoinesn(id)
          .subscribe({
            next: (response: any) => {
              if (response.data) {
                this.toastrService.success(
                  'L’offre d’emploi a été archivé avec succès.'
                );
                this.searchoffrebesoinesn();
                // this.route.navigateByUrl("/esn-offres-emploi/archived")
              }
            },
            error: (error: any) => {
            },
          });
  }

  bloquer() {
    Swal.fire({
      title: 'Es-tu sûr?',
      // text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'oui, bloquer',
    }).then((result) => {
      if (result.isConfirmed) {
      }
    });
  }

  ///////////////postuler///////////////////
  open(offre: any) {
    this.idoffre = offre.id;
  }
  getlistconsultant() {
    this.appelofferservice.getlistconsultantbyoffre(this.nameEsn).subscribe({
      next: (res: any) => {
        this.listconsultant = res.data;
        this.listresponsablesWithDisplayName();
      },
      error: (error) => {
      },
    });
  }

  listresponsablesWithDisplayName() {
    this.listconsultant.map((el: any) => {
      el.name = `${el.first_name} ${el.last_name}`;
    });
  }

  getconsultantid(e: any, userId: string) {
    if (e.target.checked) {
      this.selectedUserId = userId;
      // Décocher toutes les autres cases sauf celle qui a été cochée
      this.deselectOtherCheckboxes(userId);
    }
  }

  deselectOtherCheckboxes(currentUserId: string) {
    // Parcourir la liste des consultants et décocher les cases sauf celle qui a été cochée
    // Assurez-vous que this.consultants est la liste de vos consultants
    this.listconsultant.forEach((consultant: any) => {
      if (consultant.id !== currentUserId) {
        consultant.checked = false; // Ajoutez une propriété "checked" à votre objet consultant si elle n'existe pas
      }
    });
  }

  isDateInFuture(): boolean {
    const availibilityDate = this.applyForm.get('availibility_date')?.value;
    const today = new Date();
    const availibility = new Date(availibilityDate);
    return availibility < today;
  }

  pastDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const date = control.value;
      if (date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Ignorer les heures pour comparer uniquement les dates
        const inputDate = new Date(date);

        if (inputDate < today) {
          return { pastDate: true };
        }
      }
      return null;
    };
  }
  createForm(data?: any) {
    return this.formBuilder.group({
      commercial_argument: [data ? data.commercial_argument : ''],
      tjm_vente: [data ? data.tjm_vente : ''],
      availibility_date: [
        data ? data.availibility_date : '',
        [this.pastDateValidator()],
      ],
      user_id: [data ? data.user_id : null, [Validators.required]],
    });
  }
  concatenateNames(consultant: {
    first_name: string;
    last_name: string;
  }): string {
    return `${consultant.first_name} ${consultant.last_name}`;
  }

  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
  }

  isEsnNotSubscribed(): boolean {

    return !this.companyRoleId.includes(UserRole.ESN_UNSUBSCRIBED );
  }
  isEsnSubscribed(): boolean {
    console.log('isEsnSubscribed companyRoleId', this.companyRoleId);
    return this.companyRoleId.includes(UserRole.ADMIN_ESN ) ;
  }
  displayFreeSearch() {
    this.freeSearch = !this.freeSearch;
    this.currentPage = 0;
    if(this.freeSearch) {
       this.searchForm = this.createSearchForm();
       this.searchForm.reset();
       this.getListoffrebesoinesn();
    }
    else {
      this.freeSearchForm.reset();
      this.freeSearchForm = this.createFreeSearchForm();
      this.getListoffrebesoinesn();
    }
  }
  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  unSubscribedEsn(): boolean {
    return this.subscriptionService.unSubscribedEsn();
  }

}
